import { render, staticRenderFns } from "./Exhibits.vue?vue&type=template&id=8f73b7d4&"
import script from "./Exhibits.vue?vue&type=script&lang=js&"
export * from "./Exhibits.vue?vue&type=script&lang=js&"
import style0 from "./Exhibits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports